import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsbCarouselComponent } from './usb-carousel.component';

// Módulo propio (mismo patrón que TooltipConvertAmountModule/TooltipTaxesBreakdownModule) para
// que otros módulos chicos y autocontenidos (como TooltipTaxesBreakdownModule) puedan usar
// <usb-carousel> sin depender de SharedModule entero — evita el ciclo de imports.
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    UsbCarouselComponent
  ],
  exports: [
    UsbCarouselComponent
  ]
})
export class UsbCarouselModule { }
